import { render } from "./TransactionsBody.vue?vue&type=template&id=8c6f43b4&scoped=true"
import script from "./TransactionsBody.vue?vue&type=script&lang=js"
export * from "./TransactionsBody.vue?vue&type=script&lang=js"

import "./TransactionsBody.vue?vue&type=style&index=0&id=8c6f43b4&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c6f43b4"]])

export default __exports__